import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";

import { Label, Input, FormFeedback } from 'reactstrap';

import ParadigmaAsyncSeeker from "../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"
import DetailEmpresas from "../../clientes/Empresas/Detail.js"


import Datetime from 'react-datetime';
import 'react-datetime/css/react-datetime.css';

class Edit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fechaContacto: new Date(),
        };
    }

    static propTypes = {
        id: PropTypes.func.isRequired,
    }

    setSelects(data) {
        this.setState({
            empresa: data.empresa_id
        });
    }

    render() {
        return (
            <ParadigmaModal
                getUrl={api.proyectos.contactos.detail}
                id={this.props.id}
                successMessage={""}
                missingIdMessage={"Debe seleccionar una fila."}
                title={"Contacto"}
                buttonTitle={"Ver Contacto"}
                buttonIcon={"fa fa-search fa-lg"}
                className={"ui-modal-dialog"}
                
                saveButton={false}
                closeButton={true}
                onGotData={(data) => this.setSelects(data)}>

                <div className="ui-form">
                    <p className="ui-section-label">Datos del contacto</p>
                    <div className="ui-row-2">
                        <div className="ui-field">
                        <Label>Fecha de Contacto</Label>
                        <Datetime
                            className="display-inline-block"
                            timeFormat="HH:mm"
                            dateFormat="DD/MM/YYYY"
                            closeOnSelect={true}
                            inputProps={{ name: 'fechaContacto', disabled: true, className: 'form-control' }}
                            value={this.state.fechaContacto}
                            onChange={(e) => this.setState({ fechaContacto: e._d })}
                        />
                        </div>
                        <div className="ui-field">
                        <Label>Empresa/Organización</Label>
                        <ParadigmaAsyncSeeker Detail={DetailEmpresas} fieldName={"empresa_id"} url={api.clientes.empresas.select} value={this.state.empresa} disabled={true} />
                        <FormFeedback className="col-12"></FormFeedback>
                        </div>
                    </div>
                    <div className="ui-row-2">
                        <div className="ui-field">
                        <Label>Email</Label>
                        <Input type="text" name="email" disabled={true}></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                        </div>
                        <div className="ui-field">
                        <Label>Teléfono</Label>
                        <Input type="text" name="telefono" disabled={true}></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                        </div>
                    </div>
                    <div className="ui-row-1">
                        <div className="ui-field">
                        <Label>Observaciones</Label>
                        <Input rows={10} type="textarea" name="observaciones" disabled={true} />
                        <FormFeedback className="col-12"></FormFeedback>
                        </div>
                    </div>

                    <div className="ui-divider"></div>
                    <div className="ui-row-1">
                        <div className="ui-field">
                        <Label>Creado por</Label>
                        <Input disabled={true} type="text" name="user" />
                        </div>
                    </div>
                </div>
            </ParadigmaModal>
        );
    }
}

export default Edit;



// WEBPACK FOOTER //
// ./src/views/Proyectos/Procedimiento0/Detail.js